"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcedureController = void 0;
const ParentController_1 = __importDefault(require("../ParentController"));
class ProcedureController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/case/:objectId/procedure',
            bulkCreate: '/v1/case/:objectId/procedures',
            edit: 'v1/procedure/:objectId',
            delete: 'v1/procedure/:objectId',
            bulkDelete: '/v1/procedure/delete/_bulk',
            createOnAlert: '/v1/alert/:alertId/procedure',
            bulkCreateOnAlert: '/v1/alert/:alertId/procedures',
            deleteOnAlert: '/v1/alert/:alertId/procedure/:procedureId',
        };
    }
    bulkCreate(procedure, objectId) {
        return this.manager.post({
            url: this.endpoints.bulkCreate,
            params: { objectId },
        }, procedure);
    }
    bulkDelete(procedureListIds) {
        return this.manager.post({
            url: this.endpoints.bulkDelete,
        }, { ids: procedureListIds });
    }
    createOnAlert(procedure, alertId) {
        return this.manager.post({
            url: this.endpoints.createOnAlert,
            params: { alertId },
        }, procedure);
    }
    bulkCreateOnAlert(procedure, alertId) {
        return this.manager.post({
            url: this.endpoints.bulkCreateOnAlert,
            params: { alertId },
        }, procedure);
    }
    deleteOnAlert(procedureId, alertId) {
        return this.manager.delete({
            url: this.endpoints.deleteOnAlert,
            params: { procedureId, alertId },
        });
    }
}
exports.ProcedureController = ProcedureController;
